import React from 'react';
import CollapsibleSection from './components/CollapsibleSection';

function MastodonList({ posts }) {
  return (
    <CollapsibleSection title="Mastodon Posts">
      {posts && posts.length > 0 ? (
        posts.map((post, idx) => (
          <div className="mastodon-post" key={idx}>
            <h3><a href={post.url} target="_blank" rel="noopener noreferrer">{post.content.substring(0, 100)}...</a></h3>
            <div className="post-meta">
              <span>@{post.author}</span>
              <span>{post.replies_count} replies</span>
              <span>{post.reblogs_count} reblogs</span>
              <span>{post.favourites_count} favorites</span>
            </div>
            <p className="post-content">{post.content}</p>
          </div>
        ))
      ) : (
        <p>No Mastodon posts found</p>
      )}
    </CollapsibleSection>
  );
}

export default MastodonList; 